import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/profile.jpg';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';
import conv_illustration from '../assets/conv_illustration.gif';
import matrix from '../assets/matrix.png';
import conv from '../assets/conv.gif';
import mnp_mockup from '../assets/mnp_mockup.png';

import bolt from '../assets/bolt.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';
import pipeline from '../assets/Pipeline.png';
import pipeline2 from '../assets/Pipeline2.png';

export default {
  email,
  mobile,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  conv_illustration,
  conv, 
  mnp_mockup,
  matrix,
  bolt,
  skype,
  spotify,
  pipeline,
  pipeline2
};